import React from "react";
import Container from "ui/Container/Container";
import PhoneFilled from "assets/icons/phone-filled.svg";
import NewLogo from "assets/icons/new-logo.svg";
import { cn } from "helpers/style";
import { CONTACT_PHONE_NUMBER } from "constants/variables";
import styles from "./Header.module.scss";

type Props = {
  homeUrl: string;
};

const Header: React.FC<Props> = ({ homeUrl }) => {
  /* Logo without <Link> for full reload on navigate */
  return (
    <header className={styles.header}>
      <Container>
        <a href={homeUrl} className={styles.headerLogo}>
          <NewLogo />
        </a>
        <div className={styles.headerContacts}>
          <span
            className={cn([styles.headerContactsLabel, styles.onlyDesktop])}
          >
            Служба поддержки
          </span>

          <a
            className={styles.headerContactsLabel}
            href={`tel:${CONTACT_PHONE_NUMBER}`}
          >
            {CONTACT_PHONE_NUMBER}
          </a>

          <span className={cn([styles.headerContactsLabel, styles.time])}>
            Круглосуточно
          </span>
        </div>

        <a
          className={styles.headerContactsPhone}
          href={`tel:${CONTACT_PHONE_NUMBER}`}
        >
          <PhoneFilled />
        </a>
      </Container>
    </header>
  );
};

export default Header;
